import { useQuery, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';

export const getProjectWorkflowById = async ({
  project_id,
  workflow_id,
}: {
  project_id: any;
  workflow_id: string;
}): Promise<any> => {
  try {
    if (project_id || workflow_id) {
      const response = await axios.get(
        `${API_URL}/v2/project/${project_id}/workflows/${workflow_id}`
      );
      return response?.data;
    }
  } catch (error) {
    // console.error('Error getProjectContent:', error);
    // throw error;
  }
};

export const useGetProjectWorkflowById = (project_id: any, workflow_id: string, config = {}) => {
  const queryClient = useQueryClient();
  const { addNotification } = useNotificationStore();

  const query = useQuery<any, Error>(
    ['projectWorkflowById', project_id, workflow_id],
    () => getProjectWorkflowById({ project_id, workflow_id }),
    {
      onError: (error) => {
        addNotification({
          type: 'error',
          title: 'Failed to fetch project workflows',
          message: error.message,
        });
      },
      onSuccess: (data) => {},
      ...config,
    }
  );

  const invalidateRepoContent = async () => {
    await queryClient.invalidateQueries(['projectWorkflows', project_id]);
  };

  return { ...query, invalidateRepoContent };
};
